import { getRecommendations } from "../../../../services/recommendations";
import { getAuthorisationHeader } from "../../../../services/identity";
import { getSimilarItemsProductId } from "../../../modules/similarItems/selectors";
import {
  RECEIVE_SIMILAR_ITEMS,
  RECEIVE_SIMILAR_ITEMS_REQUEST_ID,
  SIMILAR_ITEMS_INITIALISATION_FAILURE
} from "../../../modules/similarItems/constants";
import { ServiceError } from "../../../../services/errors";
import { PERSISTENT_ERROR } from "../../../modules/common/constants";

const DEFAULT_CUSTOMER_GUID = "11111111111111111111111111111111";

const getData = () => async (dispatch, getState) => {
  const retryCallback = () => {
    dispatch({
      type: PERSISTENT_ERROR,
      payload: {
        failedActionType: SIMILAR_ITEMS_INITIALISATION_FAILURE
      }
    });
  };

  const productId = getSimilarItemsProductId(getState());

  let authorisationHeader;

  try {
    authorisationHeader = await getAuthorisationHeader();
  } catch (e) {
    authorisationHeader = `Bearer ${DEFAULT_CUSTOMER_GUID}`;
  }

  try {
    const { recommendations, recommendationsRequestId } =
      await getRecommendations({
        productId,
        authorisationHeader,
        retryCallback
      });
    dispatch({
      type: RECEIVE_SIMILAR_ITEMS,
      payload: recommendations
    });
    dispatch({
      type: RECEIVE_SIMILAR_ITEMS_REQUEST_ID,
      payload: recommendationsRequestId
    });
  } catch (e) {
    if (!(e instanceof ServiceError)) {
      throw e;
    }
    dispatch({ type: SIMILAR_ITEMS_INITIALISATION_FAILURE });

    return null;
  }
};

export default getData;
